<app-header [logoImg]="logoImg" stickyLogoImg="../../../assets/imgs/logo/se2in_logo_fullwhite.png" [stickyHeaderWhite]="true"></app-header>
<app-plan></app-plan>
<app-pricing-table></app-pricing-table>
<app-footer></app-footer>